import { CoreIcon } from '../core-icon';
import checkSVG from '../../../src/images/icons/check.svg';

export const CheckIcon = props => {
  return <CoreIcon src={checkSVG} {...props} />;
};
